export enum UserDataType {
	Logs = "logs",
	DeviceData = "deviceData",
	Config = "config",
	Documents = "documents",
	AuditLogs = "auditLogs",
}
